import { addCheckboxValue } from '@/utils/adapters'

export default {
  data: () => ({
    query: '',
    list: [],
    checkedList: [],
  }),
  methods: {
    async searchList() {
      const query = this.query
      if (!query) {
        this.list = []
      } else {
        let data = await (
          await this.$store.dispatch('updateUrlEndpoint', {
            endpoint: this.getEndpoint(query),
            fromCache: false,
          })
        ).data
        data = data.data || data.container || data.container_type
        this.list = data.map((layer) => {
          let value = false
          const index = this.checkedList.findIndex((el) => el.id === layer.id)
          if (index >= 0) {
            value = true
          }
          return addCheckboxValue({ layer, value })
        })
      }
    },
    deleteFromList(id) {
      const listIndex = this.list.findIndex((item) => item.id === id)
      const index = this.checkedList.findIndex((item) => item.id === id)

      this.checkedList.splice(index, 1)
      if (this.list[listIndex]) {
        this.list[listIndex].checked = false
      }
      this.$emit('updateSearch', this.checkedList)
    },
    checkItem(event, item) {
      const index = this.checkedList.findIndex((el) => el.id === item.id)
      if (event.target.checked) {
        if (index < 0) {
          this.checkedList.push(item)
        }
      } else {
        this.checkedList.splice(index, 1)
      }
      this.$emit('updateSearch', this.checkedList)
    },
  },
}
